import React, { createContext, useReducer, useState } from "react";
import { rankReducer } from "../components/200/reducers/rankReducer";
import { staffReducer } from "../components/200/reducers/staffReducer";
import { staffData } from "../components/200/initialStates/staffInitialState";
import { rank } from "../components/200/initialStates/rankInitialState";
import { status } from "../components/200/initialStates/statusInitialState";
import { statusReducer } from "../components/200/reducers/statusReducer";
const StaffManagementContext = createContext();

export function StaffManagementContextProvider({ children }) {
  const [state, dispatch] = useReducer(staffReducer, staffData);
  const [rankState, rankDispatch] = useReducer(rankReducer, rank);
  const [statusState, statusDispatch] = useReducer(statusReducer, status);
  const [tabState, setTabState] = useState("staffList");
  return (
    <StaffManagementContext.Provider
      value={{
        state,
        dispatch,
        rankState,
        statusState,
        rankDispatch,
        statusDispatch,
        tabState,
        setTabState,
      }}
    >
      {children}
    </StaffManagementContext.Provider>
  );
}

export default StaffManagementContext;
